module.exports = __webpack_public_path__ + "static/media/01.d8ade426.jpg";